function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Artboard",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "rotate/24x24"
}, React.createElement("path", {
  d: "M21,2 C21.5128358,2 21.9355072,2.38604019 21.9932723,2.88337887 L22,3 L22,9 C22,9.51283584 21.6139598,9.93550716 21.1166211,9.99327227 L21,10 L15,10 C14.4477153,10 14,9.55228475 14,9 C14,8.48716416 14.3860402,8.06449284 14.8833789,8.00672773 L15,8 L18.9298825,8.00024218 C17.5466793,5.60890314 14.9612294,4 12,4 C7.581722,4 4,7.581722 4,12 C4,16.418278 7.581722,20 12,20 C14.9606507,20 17.5456688,18.3917256 18.9290715,16.0011597 C19.026252,15.8449094 19.1043471,15.6932111 19.1730957,15.5511169 L19.380905,15.1150861 C19.4520016,14.9612991 19.524247,14.7979749 19.5956068,14.621832 C19.8029796,14.109958 20.3860443,13.863111 20.8979183,14.0704839 C21.4097923,14.2778567 21.6566393,14.8609214 21.4492665,15.3727953 C21.2908146,15.7639141 21.1349929,16.118004 20.9813679,16.4355266 C20.8642352,16.6776244 20.7266002,16.923195 20.5686554,17.1725904 L20.4039478,17.4232736 C18.6217071,20.1774857 15.523689,22 12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 C15.2721896,2 18.1773033,3.57163863 20.0016589,6.00123374 L20,3 C20,2.48716416 20.3860402,2.06449284 20.8833789,2.00672773 L21,2 Z",
  id: "Path"
})));

var SvgIRotateRight = function SvgIRotateRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIRotateRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/i-rotate-right.c7730b2a.svg";
export { ForwardRef as ReactComponent };